import { WEBSITE_TUNNEL_TYPES } from "app/constants";
import { fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import { fetchHotelOnlySearchFormAvailability } from "app/pages/HotelOnly/hotelOnlyActionCreator";

const SDP_FILTERS_TUNNEL_TYPES = [WEBSITE_TUNNEL_TYPES.HOLIDAYS, WEBSITE_TUNNEL_TYPES.STOPOVER];

// smartDP ne garde les filtres que d'un tunnel à la fois : charger ceux d'un onglet inactif
// écraserait les destinations et les cabines de l'onglet affiché.
export const fetchTunnelSearchFilters = ({ websiteTunnelType }) => {
	if (SDP_FILTERS_TUNNEL_TYPES.includes(websiteTunnelType)) {
		return fetchSDPFilters();
	}

	if (websiteTunnelType === WEBSITE_TUNNEL_TYPES.HOTEL_ONLY) {
		return fetchHotelOnlySearchFormAvailability();
	}

	return undefined;
};
